export const TRANSITION_TYPE = {
  DIP_TO_WHITE: 'fadewhite',
  DIP_TO_BLACK: 'fadeblack',
};

export const DEFAULT_PLAYER_RATIO = 16 / 9;

export const SQUARE_RATIO = 1;

export const CLIPS_CONTAINER_SCREEN_HEIGHT_PART = 0.2; // Clips list is allowed to get MAX 20% of the screen height

export const MIN_CARD_LIST_HEIGHT = 100;

export const START_LIST_HEIGHT_FOR_MINI = 130;

export const MAX_CARD_LIST_HEIGHT = 195;

export const INITIAL_CLIPS_LIST_PADDING = 16;

export const PADDING_COEFFICIENT = MAX_CARD_LIST_HEIGHT / INITIAL_CLIPS_LIST_PADDING; // Max card list height / min card list height

export const CLIP_ORGANIZER_TOP_BOTTOM_MARGINS = 64;
